import React from 'react';

import Content from '@components/Dashboard/AdminPanel';

const AdminPanel: React.FC = () => {
  return <Content />;
};

export default AdminPanel;
